module.exports = __webpack_public_path__ + "static/media/delete_outline.7503ded7.svg";